export const paths = {
  GLOBAL: 'global',
  ID: ':db/id',
  NOTIFICATION_SETTINGS: ':user/notification-settings',
  TYPE: ':notification-setting/type',
  CHANNELS: ':notification-setting/channels',
  BOARD: ':notification-setting/board'
}
